import { render, staticRenderFns } from "./Booklist.vue?vue&type=template&id=60375061&scoped=true&"
import script from "./Booklist.vue?vue&type=script&lang=js&"
export * from "./Booklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60375061",
  null
  
)

export default component.exports